<template>
  <div class="top-bar main-navbar bg-white border-bottom sticky-top">
    <d-navbar type="light" class="align-items-stretch flex-md-nowrap p-0">
      <a
        href="#"
        class="nav-link nav-link-icon toggle-sidebar text-center border-right" @click="handleToggleSidebar" >
        <i class="material-icons">&#xE5D2;</i>
      </a>
      <figure class="logo-wrapper flex my-0">
        <router-link to="/kokpit" class="my-auto mx-auto" style="display:block; text-align:center;">
            <img
            id="main-logo"
            style="max-width: 110px;"
            src="@/assets/images/headwear.jpg"
            alt="HeadWear CRM">
        </router-link>
      </figure>

      <ul class="navbar-nav border-left flex-row ml-auto">
        <li
          v-if="userIsAdminOrWorker"
          class="nav-item border-right">
          <d-link
            class="nav-link nav-link-icon text-center"
            @click.prevent="$bus.$emit('sidebar-products-search-popup-show')"
            title="Wyszukaj produkty">
            <div class="nav-link-icon__wrapper">
              <i class="material-icons">manage_search</i>
            </div>
          </d-link>
        </li>

        <li
          v-if="getItem('/powiadomienia')"
          class="nav-item border-right">
          <d-link
            class="nav-link nav-link-icon text-center"
            :to="getItem('/powiadomienia').to"
            :title="getItem('/powiadomienia').title[currentLanguage]">
            <div class="nav-link-icon__wrapper">
              <div v-if="getItem('/powiadomienia').htmlBefore" v-pure-html="getItem('/powiadomienia').htmlBefore"></div>
            </div>
          </d-link>
        </li>

        <li class="nav-item border-right position-relative">
          <a
            href="#"
            class="nav-link nav-link-icon text-center"
            @click.prevent="$bus.$emit('system-messages-drawer-toggle')"
            title="komunikaty systemowe">
            <div class="nav-link-icon__wrapper">
              <i class="material-icons">notifications</i>
              <d-badge
                v-if="getUnreadSystemMessagesCount > 0"
                pill
                theme="danger"
                class="notification-badge">
                {{ getUnreadSystemMessagesCount }}
              </d-badge>
            </div>
          </a>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle text-nowrap px-3" v-d-toggle.user-actions>
            <i class="material-icons mr-2">person</i>
            <span class="d-none d-md-inline-block">{{ getUserEmail }}</span>
          </a>
          <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small">
            <d-dropdown-item
              v-if="getItem('/moje-konto')"
              :to="getItem('/moje-konto').to"
              class="text-dark">
              <i class="material-icons mr-2 text-primary">verified_user</i>
              {{ getItem('/moje-konto').title[currentLanguage] }}
            </d-dropdown-item>

            <d-dropdown-divider v-if="getItem('/moje-konto')" />

            <d-dropdown-item
              v-if="getItem('/wyloguj')"
              :to="getItem('/wyloguj').to"
              class="text-danger">
              <i class="material-icons mr-2 text-danger">power_settings_new</i>
              {{ getItem('/wyloguj').title[currentLanguage] }}
            </d-dropdown-item>
          </d-collapse>
        </li>
      </ul>
    </d-navbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import getTopbarItems from '@/data/topbar-nav-items';
import getPrefferedLanguage from '@/utils/i18nUtils.js';

export default {
  name: 'main-topbar',
  computed: {
    ...mapGetters(['getUserEmail', 'getUnreadSystemMessagesCount']),
    userIsAdminOrWorker () {
      return this.$store.getters.getUserType === 'admin' || this.$store.getters.getUserType === 'worker';
    },
    currentLanguage () {
      return getPrefferedLanguage();
    },
    allowedNavItems () {
      const allItems = getTopbarItems();
      return allItems.filter(item => {
        if (item.permission === false || item.permission === undefined) {
          return true;
        }
        return this.$store.getters.getUserPermission(item.permission);
      });
    }
  },
  methods: {
    handleToggleSidebar () {
      this.$bus.$emit('toggle-sidebar');
    },
    getItem (path) {
      return this.allowedNavItems.find(item => item.to === path);
    }
  }
};
</script>

<style scoped>
.notification-badge {
  position: absolute;
  top: 2px;
  right: 5px;
  padding: 0px 5px;
  font-size: 10px;
}
</style>
